import React, {PropTypes} from 'react';
import StandardModal from 'shared/StandardModal.jsx';

const OrderReviewConfirmationModal = ({
  visible,
  onCancelClick,
  onContinueClick
}) =>(
  <StandardModal
    title="Clear Cart"
    visible={visible}
    onCloseClick={onCancelClick}>
      <div>
        <div>
          {`You are about to remove all items from the cart. Are you sure?`}
        </div>
        <div className="text-right">
            <button
              type="button"
              className="btn btn-link"
              onClick={() => onCancelClick()}
            >{'Cancel'}</button>
            {` `}
            <button
              type="submit"
              className="btn btn-primary btn-lg"
              onClick={() => onContinueClick()}
            >{`I'm Sure`}</button>
        </div>
      </div>
    </StandardModal>
);

OrderReviewConfirmationModal.propTypes = {
  visible: PropTypes.bool,
  onCancelClick: PropTypes.func,
  onContinueClick: PropTypes.func
};

export default OrderReviewConfirmationModal;



// WEBPACK FOOTER //
// ./src/features/shared/ClearCartConfirmationModal.jsx